import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_optive-showcase/artifacts/li0w3a02_Blue%20Logo%20.jpg"
              alt="Optive Digital"
              className="h-12 w-auto"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium digital marketing agency helping businesses grow with creative design and powerful advertising strategies.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#3B82F6] transition-colors" data-testid="social-facebook">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#3B82F6] transition-colors" data-testid="social-instagram">
                <Instagram size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#3B82F6] transition-colors" data-testid="social-linkedin">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-[#3B82F6] transition-colors text-sm" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-[#3B82F6] transition-colors text-sm" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/packages" className="text-gray-400 hover:text-[#3B82F6] transition-colors text-sm" data-testid="footer-link-packages">Packages</Link></li>
              <li><Link to="/portfolio" className="text-gray-400 hover:text-[#3B82F6] transition-colors text-sm" data-testid="footer-link-portfolio">Portfolio</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-[#3B82F6] transition-colors text-sm" data-testid="footer-link-about">About Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Social Media Marketing</li>
              <li className="text-gray-400 text-sm">Video Editing</li>
              <li className="text-gray-400 text-sm">Creative Design</li>
              <li className="text-gray-400 text-sm">Meta Ads Management</li>
              <li className="text-gray-400 text-sm">GMB Optimization</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone size={16} className="text-[#3B82F6] mt-1 flex-shrink-0" />
                <div className="text-gray-400 text-sm">
                  <a href="tel:+918059967351" className="hover:text-[#3B82F6] transition-colors">+91-8059967351</a><br />
                  <a href="tel:+919896111251" className="hover:text-[#3B82F6] transition-colors">+91-9896111251</a>
                </div>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={16} className="text-[#3B82F6] flex-shrink-0" />
                <a href="mailto:optivedigital@gmail.com" className="text-gray-400 text-sm hover:text-[#3B82F6] transition-colors">
                  optivedigital@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="text-[#3B82F6] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Karnal, Haryana</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Optive Digital. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;